import { useState } from "react";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const PhonepeStrategy = () => {
  const [isPrevStDisabled, setIsPrevStDisabled] = useState(true);
  const [isNextStDisabled, setIsNextStDisabled] = useState(false);

  const handleStrategy = (strategyswiper) => {
    setIsPrevStDisabled(strategyswiper.isBeginning);
    setIsNextStDisabled(strategyswiper.isEnd);
  };

  return (
    <>
      {" "}
      <div className="why-custom-swiper">
        <Swiper
          spaceBetween={20}
          slidesPerView={4}
          modules={[Navigation, A11y, Pagination]}
          pagination={{
            clickable: true,
          }}
          scrollbar={{ draggable: true }}
          navigation={{
            prevEl: ".ph-st-prev-btn",
            nextEl: ".ph-st-next-btn",
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}
          onSlideChange={handleStrategy}
          onReachBeginning={() => setIsPrevStDisabled(true)}
          onReachEnd={() => setIsNextStDisabled(true)}
          onFromEdge={() => {
            setIsPrevStDisabled(false);
            setIsNextStDisabled(false);
          }}
        >
          <SwiperSlide>
            <div className="ph-swiper-cards-one-outer">
              <div className="ph-swiper-cards-one ph-st-one">
                <h6>Scalability and Customization</h6>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="ph-swiper-btn"
                >
                  <span className="ph-btn-txt"> Know More</span>{" "}
                  <span className="ph-btn-icon">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="ph-swiper-cards">
              <img
                src={require("../../../image/phonepe/st-img-one.webp")}
                alt="PhonePe Clone App"
              />
              <h6>Pre-Launch Preparations</h6>
              <ul>
                <li>Conduct market research to identify user needs.</li>
                <li>Build hype through social media campaigns and teasers.</li>
              </ul>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="ph-swiper-cards">
              <img
                src={require("../../../image/phonepe/st-img-two.webp")}
                alt="PhonePe Clone App"
              />
              <h6>User Acquisition</h6>
              <ul>
                <li>Offer introductory discounts and cashback rewards.</li>
                <li>Partner with merchants to drive app adoption.</li>
              </ul>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="ph-swiper-cards">
              <img
                src={require("../../../image/phonepe/st-img-three.webp")}
                alt="PhonePe Clone App"
              />
              <h6>Digital Marketing</h6>
              <ul>
                <li>Leverage SEO, PPC, and social media ads.</li>
                <li>
                  Engage users through blogs, email campaigns, and influencers.
                </li>
              </ul>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="ph-swiper-cards">
              <img
                src={require("../../../image/phonepe/st-img-four.webp")}
                alt="PhonePe Clone App"
              />
              <h6> Feedback and Optimization</h6>
              <ul>
                <li>Gather user feedback to improve the app.</li>
                <li>
                  Consistently update the app with new features and
                  improvements.
                </li>
              </ul>
            </div>
          </SwiperSlide>
        </Swiper>

        <div className="why-custom-btn-wrapper st-key-btn-wrapper ph-swiper-btn-wrap">
          <button
            className={`ph-st-prev-btn ph-left-btn ${
              isPrevStDisabled ? "disabled" : ""
            }`}
            style={{
              color: isPrevStDisabled ? "#6E6F70" : "#0f0f0f",
              cursor: isPrevStDisabled ? "not-allowed" : "pointer",
            }}
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <button
            className={`ph-st-next-btn  ph-right-btn ${
              isNextStDisabled ? "disabled" : ""
            }`}
            style={{
              color: isNextStDisabled ? "#6E6F70" : "#0f0f0f",
              cursor: isNextStDisabled ? "not-allowed" : "pointer",
            }}
          >
            <i className="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </>
  );
};

export default PhonepeStrategy;
